import template from './item_type.edit.html';
import controller from './item_type.edit.controller';
import './item_type.edit.scss';

let itemTypeEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default itemTypeEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/item_type/edit/item_type.edit.component.js